import { render, staticRenderFns } from "./TableTask.vue?vue&type=template&id=39f820f6"
import script from "./TableTask.vue?vue&type=script&lang=ts"
export * from "./TableTask.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports